import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/**
 * Edits a société's name, whether guests can read its exhibitions/findings
 * at all, and (once that's on) which cross-origin domains may (more
 * fields planned later) - edit-only, unlike ExhibitionEditModal/
 * ExhibitionFindingEditModal's create-or-edit shape, since SocietyResource
 * has no Create endpoint (the 4 rows are fixed, seeded once at install).
 */
export default class SocietyEditModal extends Modal {
  name = '';
  allowedOrigins = '';
  isPublic = false;
  loading = false;
  errorMessage = null;
  oninit(vnode) {
    super.oninit(vnode);
    this.name = this.attrs.society.name() || '';
    this.allowedOrigins = this.attrs.society.allowedOrigins() || '';
    this.isPublic = this.attrs.society.isPublic();
    this.loading = false;
    this.errorMessage = null;
  }
  className() {
    return 'Modal--small ChampisSocietyEditModal';
  }
  title() {
    return app.translator.trans('champis-exhibitions.forum.society_edit_modal.title');
  }
  content() {
    const t = key => app.translator.trans(`champis-exhibitions.forum.society_edit_modal.${key}`);
    return m("div", {
      className: "Modal-body"
    }, this.errorMessage && m("div", {
      className: "ChampisSocietyEditModal-error"
    }, this.errorMessage), m("div", {
      className: "ChampisSocietyEditModal-field"
    }, m("label", null, t('name_label'), m("input", {
      className: "FormControl",
      type: "text",
      value: this.name,
      oninput: e => {
        this.name = e.target.value;
      }
    }))), m("div", {
      className: "ChampisSocietyEditModal-field"
    }, m("label", null, m("input", {
      type: "checkbox",
      checked: this.isPublic,
      onchange: e => {
        this.isPublic = e.target.checked;
      }
    }), ' ', t('is_public_label')), m("p", {
      className: "helpText"
    }, t('is_public_help'))), m("div", {
      className: "ChampisSocietyEditModal-field"
    }, m("label", null, t('allowed_origins_label'), m("input", {
      className: "FormControl",
      type: "text",
      placeholder: t('allowed_origins_placeholder'),
      value: this.allowedOrigins,
      oninput: e => {
        this.allowedOrigins = e.target.value;
      }
    })), m("p", {
      className: "helpText"
    }, t('allowed_origins_help'))), m("div", {
      className: "ChampisSocietyEditModal-footer"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.submit(),
      loading: this.loading,
      disabled: !this.name.trim()
    }, t('save_button'))));
  }
  submit() {
    this.loading = true;
    this.errorMessage = null;
    m.redraw();
    this.attrs.society.save({
      name: this.name.trim(),
      allowedOrigins: this.allowedOrigins.trim() || null,
      isPublic: this.isPublic
    }).then(() => {
      this.loading = false;
      this.hide();
      if (this.attrs.onsaved) this.attrs.onsaved();
    }).catch(error => {
      this.loading = false;
      this.errorMessage = error && error.message || app.translator.trans('champis-exhibitions.forum.society_edit_modal.error');
      m.redraw();
    });
  }
}
flarum.reg.add('champis-exhibitions', 'forum/components/SocietyEditModal', SocietyEditModal);